import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IssueType } from '../IssueTypesContext/types'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { HelpMessage } from 'utils/constants'
import { CIMSPage } from '@cims-online/shared'
import { CIMSTags } from 'components/CIMSTags'

export function useColumns(): CIMSColumn<IssueType>[] {
  const help = HelpMessage.Issues.IssueTypes
  return [
    useNameColumn({ sort: { default: 'ascend' }, help: HelpMessage.Name }),
    useOptionalDescriptionColumn('Type'),
    {
      title: 'Non-Applicable Disposition Types',
      help: help.NonApplicableDispositionTypes,
      link: CIMSPage.IssueDispositionTypes,
      render: ({ nonApplicableIssueDispositionTypes }) => (
        <CIMSTags
          tags={nonApplicableIssueDispositionTypes.map(
            ({ name, description, deleted }) => ({
              text: name,
              tooltip: description,
              strikethrough: deleted,
            })
          )}
        />
      ),
      filter: {
        type: 'default',
        with: 'callback',
        items: (records) =>
          records.flatMap(({ nonApplicableIssueDispositionTypes }) =>
            nonApplicableIssueDispositionTypes.map(
              ({ id, name, description }) => ({
                text: name,
                tooltip: description,
                value: id,
              })
            )
          ),
        onFilter: (value, { nonApplicableIssueDispositionTypes }) =>
          nonApplicableIssueDispositionTypes.some(({ id }) => id === value),
      },
      width: 280,
    },
  ]
}
